module.exports = __webpack_public_path__ + "5c5366b1f5b76daff0d537db7e210c21.woff2";